import { type FunctionComponent, type ReactNode } from "react";

import { useStickyTotalSize } from "./StickyContext";
import { type IStickyLayer, type StickyDirection } from "./StickyContext.type";
import { StickyProvider } from "./StickyProvider";

interface IStickyCurrentLevelProviderProps {
  children: ReactNode;
  direction: StickyDirection;
  level: number | undefined;
}
export const StickyCurrentLevelProvider: FunctionComponent<
  IStickyCurrentLevelProviderProps
> = ({ children, direction, level = 0 }) => {
  const size = useStickyTotalSize(direction, level);
  const currentLayer: IStickyLayer = { size, level: 0 };

  return (
    <StickyProvider initialTopLayer={currentLayer}>{children}</StickyProvider>
  );
};
